module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_c('i', [_vm._v("Everywhere in the world, the")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("land refused to bear fruit")]), _vm._v(" …")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("The sun shone cloudless in the sky and the rivers dropped and the seas shrank and the creeks and brooks dried up and the mountains were sear and the valleys yellowed all over the world.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("The land hated us, the violated land, the faithful land, the exploited and gentle land. The land decided that we must die, and all innocent living things with us.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("The land had cursed us.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("Our wars and our hatred—these had finally sickened the wise earth.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("We did not know then that we stood indicted as the irreconcilable enemy of all life.…")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7266587b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 66
// module chunks = 0